<template>
  <div class="mb-4">
    <ul class="nav nav-pills nav-justified">
      <li class="nav-item waves-effect waves-light">
        <router-link
          class="nav-link"
          :class="{ 
            active: seccion == 'clientesPorSitio'
          }"
          :to="{ name: 'listadoReporteClientesSitio' }"
        >
          Clientes por sitio
        </router-link>
      </li>
      <li class="nav-item waves-effect waves-light">
        <router-link
          :to="{ name: 'reportesFacturas' }"
          class="nav-link"
          v-if="usuario.root == true"
          :class="{ 
            active: seccion == 'reportes'
          }"
        >
          Reportes
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CmpSecciones',
  props: ['seccion'],
  computed: {
    usuario: function() {
      return this.$store.state.todo.usuario
    }
  }
}
</script>

<style scoped>

</style>